import { type Scalars } from 'cms/cms-types';
import { format } from 'date-fns';

export const resolveDate = (value: Scalars['Date']): string | undefined => {
    if (!value) {
        return undefined;
    }

    const date = new Date(value as unknown as string | number | Date);
    return format(date, 'd MMM yyyy');
};
